module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    staticClass: "popup-time-range",
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "half-pop-content",
    style: ({
      'height': _vm.windowHeight
    })
  }, [_c('div', {
    staticClass: "time-range-title flex-row flex-align-center"
  }, [_c('div', {
    staticClass: "flex-1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('scroll', {
    staticClass: "half-scroll",
    staticStyle: {
      "background-color": "white"
    }
  }, [_vm._t("list")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361d3cbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapWindow.vue
// module id = 810
// module chunks = 0